// Information needed for connecting to our CraftQL endpoint
export const apiToken = 'kn50xPt1QHQzs-NN2SmB81Xy2Q5Eg7BB1CBUAt23H0ha8Wsg4-Es3HO1mjnP5OYF';
export const apiUrl = '/api';

// Configure the api endpoint
export function configureApi (url, token) {
    return {
        baseURL: url,
        headers: {
            'Authorization': `Bearer ${token}`,
            'X-Requested-With': 'XMLHttpRequest'
        }
    };
};

// Execute a GraphQL query by sending an XHR to our api endpoint
export function executeQuery (api, query, variables, callback) {
    api.post('', {
        query: query,
        variables: variables
    }).then((result) => {
        if (callback) {
            callback(result.data);
        }
    }).catch((error) => {
    })
};

let query = window.location.search.substring(1);
export function getQueryParam(param) {
  if (query.length === 0) {
    return false;
  }
  let params = decodeURIComponent(query).split('&');
  let results = [];
  for (let i = 0; i < params.length; i++) {
    let pair = params[i].split('=');
    if (decodeURIComponent(pair[0]) === param) {
      results.push(decodeURIComponent(pair[1]))
    }
  }
  if (results.length === 0) {results = '';}
  if (results.length === 1 && param !== 'cat' && param !== 'cat-id') {results = results[0];}

  return results;
}
